export enum UserLevel {
	Guest = 0,
	User = 1,
	SuperUser = 2,
	Admin = 3,
}

export enum ShowType {
	Hide = 0,
	Test = 1,
	Show = 2,
}

export enum OperationType {
	Sum = 0,
	Subtract = 1,
}

export enum RangeType {
	Recursive = 0,
	Single = 1,
}
